import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getDisplayAmount } from "./ManageSubscriptionForm";
import Icon from "@material-ui/core/Icon";
import Icons from "../../helpers/iconImports";
import { useTranslation } from "react-i18next";
import { IProduct } from "../../services/dashboard.services";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subItemBox: {
      paddingBottom: "20px",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "0.9rem",
      height: "20px",
    },
    subTextGrid: {
      width: "45px",
    },
    itemText: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      height: "20px",
    },
    total: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      height: "20px",
      fontWeight: "bold",
    },
    totalChanged: {
      fontSize: "0.85rem",
      height: "20px",
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
    quantityButton: {
      minHeight: "15px",
      minWidth: "15px",
      maxHeight: "15px",
      maxWidth: "15px",
    },
    quantityBox: {
      display: "flex",
      justifyContent: "center",
    },
    quantityText: {
      color: theme.palette.dark.main,
      display: "flex",
      width: "30px",
      fontWeight: "bold",
      fontSize: "0.85rem",
      justifyContent: "center",
    },
    quantityChanged: {
      display: "flex",
      width: "30px",
      fontWeight: "bold",
      fontSize: "0.85rem",
      justifyContent: "center",
      color: theme.palette.primary.main,
    },
    productBox: {
      display: "flex",
    },
    addRemoveIcons: {
      fontSize: "large",
      color: "#D0D0D0",
    },
    imageIcon: {
      display: "flex",
      height: "15px",
      width: "15px",
      marginTop: "20%",
      marginLeft: "20%",
    },
  })
);

export default function NewSubscriptionItemLayout(props: IProps) {
  // Component styles
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    amount,
    id,
    quantity,
    product,
    itemQuantity,
    handleSetItemQuantity,
  } = props;

  const [amountTotal, setAmountTotal] = useState((amount / 100) * quantity);
  const addQuantity = () => {
    const count = itemQuantity[id];
    handleSetItemQuantity(id, count + 1);
    setAmountTotal((amount / 100) * (count + 1));
  };
  const deleteQuantity = () => {
    const count = itemQuantity[id];
    if (count > 0) {
      handleSetItemQuantity(id, count - 1);
      setAmountTotal((amount / 100) * (count - 1));
    } else {
      handleSetItemQuantity(id, 0);
    }
  };

  let changed = quantity !== itemQuantity[id];

  /* Hooks */
  return (
    <Box className={classes.subItemBox}>
      <Typography className={classes.productText}>
        {product.name} {t("gateways")}
      </Typography>
      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>Price:</Grid>
          <Grid>
            {getDisplayAmount(amount / 100, product.country)} {t("each")}
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>{t("quantity")}</Grid>
          <Grid className={classes.quantityBox}>
            <Button className={classes.quantityButton} onClick={deleteQuantity}>
              <Icon>
                <img
                  className={classes.imageIcon}
                  src={Icons.ButtonMinusIcon}
                  alt={""}
                  draggable={false}
                />
              </Icon>
            </Button>
            <Typography
              className={
                changed ? classes.quantityChanged : classes.quantityText
              }
            >
              {itemQuantity[id]}
            </Typography>
            <Button className={classes.quantityButton} onClick={addQuantity}>
              <Icon>
                <img
                  className={classes.imageIcon}
                  src={Icons.ButtonPlusIcon}
                  alt={""}
                  draggable={false}
                />
              </Icon>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>{t("total") + ":"}</Grid>
          <Grid>
            <Typography
              className={changed ? classes.totalChanged : classes.total}
            >
              {getDisplayAmount(amountTotal, product.country)}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

interface IProps {
  amount: number;
  id: string;
  quantity: number;
  productID: string;
  product: IProduct;
  itemQuantity: { [key: string]: number };
  handleSetItemQuantity: (planId: string, quantity: number) => void;
}
